module.exports = __webpack_public_path__ + "img/logo.90df7cf0.png";